import { HStack } from '@chakra-ui/react'
import type { Control } from 'react-hook-form'
import { useWatch } from 'react-hook-form'
import { diffFromOrigin } from './diffFromOrigin'
import { EditableGridButtons } from './EditableGridButtons'

interface EditableGridHeaderProps<TRow extends { id: any }> {
    control: Control<any>
    originMap: Map<TRow['id'], TRow>
    rowsEqual: (a: TRow, b: TRow) => boolean
    addRow: () => void
    cancelChanges: () => void
    isSubmitting: boolean
    handleSubmit: () => Promise<any> | void
    headerItems?: React.ReactNode
    level: number
    grayShades: string[]
}

export function EditableGridHeader<TRow extends { id: any }>({
    control,
    originMap,
    rowsEqual,
    addRow,
    cancelChanges,
    isSubmitting,
    handleSubmit,
    headerItems,
    level,
    grayShades
}: EditableGridHeaderProps<TRow>) {

    const rows = useWatch({
        control,
        name: 'root'
    }) as TRow[]

    const { created, edited, deletedIds, hasChanges } = diffFromOrigin(originMap, rows || [], rowsEqual)

    return (
        <HStack justify="space-between" px={8} py={4} borderBottom='1px solid' borderColor={grayShades[level + 1]}
            pos='sticky' top={0} bg={grayShades[level]} zIndex={1 + level}>
            <EditableGridButtons
                hasChanges={hasChanges}
                addRow={addRow}
                cancelChanges={cancelChanges}
                isSubmitting={isSubmitting}
                created={created}
                edited={edited}
                deletedIds={deletedIds}
                handleSubmit={handleSubmit}
            />

            <HStack>
                {headerItems}
            </HStack>
        </HStack>
    )
}
